import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { getModalData } from "src/selectors";
import { hideModal } from "src/actions/modal.actions";
import { deleteCatalogDiscount } from "src/actions/accountDetailsActions/billing.actions";

class DeleteDiscountModal extends Component {
    closeModal = () => {
        this.props.hideModal();
    };

    confirmDelete = () => {
        this.props.deleteCatalogDiscount(this.props.modalProps.value.id).then((response) => {
            if (response && response.data && response.data.success) {
                toastr.success('Discount has been deleted successfully!', { timeOut: 1000, position: 'top-center' });
            } else {
                const errorMessage = response?.data?.error?.message || 'Could not delete the discount.';
                toastr.error(errorMessage, { timeOut: 3000, position: 'top-center' });
            }
            this.props.hideModal();
            this.props.modalProps.reloadFunction();
        });
    };

    render() {
        return (
            <Fragment>
                <div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">CONFIRM DELETING DISCOUNT</h5>
                                <button type="button" className="close" onClick={this.closeModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="lead">Are you sure you want to delete <strong>{this.props.modalProps.value?.name}</strong>?</p>
                            </div>
                            <div className="modal-footer">
                                <button onClick={this.closeModal} className="btn">
                                    No
                                </button>
                                <button onClick={this.confirmDelete} className="btn btn-primary">
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show" tabIndex="1" />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    modalProps: getModalData(state).modalProps,
});

const mapDispatchToProps = {
    hideModal,
    deleteCatalogDiscount,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteDiscountModal);